import React from "react";
//#region types
import { RutRotSelectionProps, RutRotSummaryProps } from "models/propTypes/invoicePropTypes";
import { TranslationKeys } from "translations";
import { SelectionChipsProps } from "models/propTypes/wintFormPropsTypes";
//#endregion
//#region components
import { HorizontalFormField, WizardSection, SelectionChips } from "components/common/wintForms";
import QuotationRutRotSelector from "./rutRotSelector";
import QuotationRutRotSummary from "./rutRotSummary";
import { useInvoiceService } from "serviceHooks";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const QuotationRutRotSelectionStep: React.FC<RutRotSelectionProps> = (props) => {
  const invoiceService = useInvoiceService();
  const { connect, values, errors, touched, submitted, wizardProps: wizardStepProps, hasROT, hasRUT } = props;

  const hasErrors = connect("rutRot").hasErrors;

  const onProductsUpdate = () => {
    const products = values.products ?? [];
    const rutRotArticles = values.rutRot?.rutRotArticles ?? [];
    if (rutRotArticles.length === 0) return;
    if (!rutRotArticles.some((rr) => !products.some((p) => p.uniqueId === rr.id))) return;

    const filteredRutRotArticles = rutRotArticles.filter((rr) => products.some((p) => p.uniqueId === rr.id));
    connect("rutRot.rutRotArticles").setValue(filteredRutRotArticles);
  };

  React.useEffect(() => {
    onProductsUpdate();
  }, [values.products]);

  return (
    <WizardSection
      header={invoiceService.getRutRotTabHeader(hasROT, hasRUT)}
      description={TranslationKeys.Invoice.RutRotDescription}
      submitted={submitted}
      wizardProps={wizardStepProps}
      hasErrors={hasErrors}
      testId="quotationRutRotSelectionStep"
    >
      <HorizontalFormField<SelectionChipsProps>
        Component={SelectionChips}
        {...connect("rutRot.houseWorkType")}
        label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.RutRotInvoice)}
        descriptionText={LocalizationHelperInstance.getFormattedMessage(
          TranslationKeys.Invoice.RutRotInvoiceDescription
        )}
        items={invoiceService.getHouseWorkTypes()}
        disabledItems={invoiceService.getDisabledHouseWorkTypes(hasROT, hasRUT)}
      />
      {values.rutRot?.houseWorkType ? (
        <>
          <QuotationRutRotSelector connect={connect} values={values} errors={errors} touched={touched} />
          <HorizontalFormField<RutRotSummaryProps>
            Component={QuotationRutRotSummary}
            {...connect("rutRot.rutRotSummary")}
            label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.RutRotSummary)}
            values={values}
          />
        </>
      ) : (
        <></>
      )}
    </WizardSection>
  );
};

export default QuotationRutRotSelectionStep;
